<template>
  <LoginView/>
  <section id="client" v-if="global.authenticated">
    <div class="overlay">
      <div class="container">
        <div class="d-flex align-items-start flex-column justify-content-center">
          <table className="main-setings">
            <tr>
              <td className="cell">Дата начала:</td>
              <td className="cell"><input type="date" v-model="generateScheduleStartDate"/></td>
            </tr>
            <tr>
              <td className="cell">Дата конца:</td>
              <td className="cell"><input type="date" v-model="generateScheduleEndDate"/></td>
            </tr>
            <tr>
              <td className="cell"></td>
              <td className="cell">
                <input className="btn btn-sm main-btn text-uppercase" :disabled="loading"
                @click="reportСlientАmount()()"
                value="Получить отчет">
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<style>
  #client .overlay{
  background: none;
}
  #client table{
  background: #fff;
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.12);
}
  #client .main-setings{
  margin-top: 30px;
}
  #client .cell{
  height: 52px;
  padding: 1px 16px;
  text-align: left;
}
  #client .modal-dialog{
  width: 400px;
}
  #client .modal-dialog .btn-primary{
  width: 100%;
}
  #client .modal-dialog input{
  width: 100%;
}
  #client .btn-sm{
    border-radius: 100px;
  min-width: 150px;
}

</style>

<script>
  import LoginView from '@/views/LoginView.vue'
  import {global} from "@/global.js";

export default {
  name: 'LkReportView',
    client:{name:"",phone:""},
  components: {
    LoginView
  },
  data() {
    return {
      global: global,
  subjects:[],
  loading:false,
      account:{subjects:[]},
      clients:[],
      client: {name: "", phone: "", email: ""},
      generateScheduleStartDate: new Date().toISOString().substr(0, 10),
      generateScheduleEndDate: new Date().toISOString().substr(0, 10)
    }
  },

  mounted() {
    global.value.lk=true;
    if(global.value.authenticated) {
      this.load();
    }else {
      setTimeout(function () {
        if (global.value.authenticated) {
          this.load();
        }
      }.bind(this), 1000);
    }
  },


  methods: {
    load(){
  },


  reportСlientАmount(){
  window.open(global.value.url + "lk/report/client-amount?startDate="+this.generateScheduleStartDate+"&endDate="+this.generateScheduleEndDate, '_blank');
  /*this.loading = true;
  this.accountErorr = "";
  axios.post(global.value.url + "lk/report/client-amount?startDate="+this.generateScheduleStartDate+"&endDate="+this.generateScheduleEndDate)
    .then(response => {
      if(response.data.success){
        new Toast({
          title: false,
          text: response.data.text,
          theme: 'success',autohide: true,interval: 10000
        });
      }else{
        new Toast({
          title: false,
          text: response.data.text,
          theme: 'danger',autohide: true,interval: 10000
        });
      }
      this.errored = false;
    })
    .catch(() => {
      this.accountErorr="Ошибка сохранения";
      this.errored = true;
    })
    .finally(() => (this.loading = false));*/
}
}

}
</script>
